module.exports = __webpack_public_path__ + "img/eb8e110.jpg";